<template>
    <!-- Main Header-->
    <header class="main-header header-style-two alternate-two">
		<div class="main-box">
            <div class="auto-container clearfix">
                <div class="logo-box">
                    <div class="logo">
                        <a href="index.html">
                            <img src="@/assets/images/logo.png" alt="" title="">
                        </a>
                    </div>
                </div>

                <!--Nav Box-->
                <div class="nav-outer clearfix">
                    <!--Mobile Navigation Toggler-->
                    <div class="mobile-nav-toggler"><span class="icon flaticon-menu"></span></div>
                    <!-- Main Menu -->
                    <nav class="main-menu navbar-expand-md navbar-light">
                        <div class="navbar-header">
                            <!-- Togg le Button -->
                            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="icon flaticon-menu-button"></span>
                            </button>
                        </div>

                        <div class="collapse navbar-collapse clearfix" id="navbarSupportedContent">
                            <ul class="navigation clearfix">
                                <li class="current dropdown"><a href="index.html">Home</a>
                                    <ul>
                                        <li><a href="index.html">Home Classic</a></li>
                                        <li><a href="index-2.html">Home Conference</a></li>
                                        <li><a href="index-3.html">Home Meetup</a></li>
										<li><a href="index-4.html">Home Page Four</a></li>
                                        <li><a href="index-5.html">Home Page Five</a></li>
                                        <li class="dropdown"><a href="#">Header Styles</a>
                                            <ul>
                                                <li><a href="index.html">Header Style One</a></li>
                                                <li><a href="index-2.html">Header Style Two</a></li>
                                                <li><a href="index-3.html">Header Style Three</a></li>
												<li><a href="index-4.html">Home Page Four</a></li>
												<li><a href="index-5.html">Home Page Five</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li class="dropdown"><a href="about-us.html">About</a>
                                    <ul>
                                        <li><a href="about-us.html">About Us</a></li>
                                        <li><a href="pricing.html">Pricing</a></li>
                                        <li><a href="faqs.html">FAQ's</a></li>
										<li><a href="gallery.html">Gallery</a></li>
                                        <li><a href="coming-soon.html">Coming Soon</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown"><a href="speakers.html">Speakers</a>
                                    <ul>
                                        <li><a href="speakers.html">Speakers</a></li>
                                        <li><a href="speakers-detail.html">Speakers Detail</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown"><a href="schedule.html">Schedule</a>
                                    <ul>
                                        <li><a href="schedule.html">Schedule</a></li>
                                        <li><a href="event-detail.html">Event Detail</a></li>
                                        <li><a href="buy-ticket.html">Buy Ticket</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown"><a href="blog-sidebar.html">Blog</a>
                                    <ul>
                                        <li><a href="blog-sidebar.html">Blog With Sidebar</a></li>
                                        <li><a href="blog-grid.html">Blog Grid</a></li>
                                        <li><a href="blog-single.html">Blog Single</a></li>
                                        <li><a href="error-page.html">404 Error</a></li>
                                    </ul>
                                </li>
                                <li><a href="contact.html">Contact</a></li>
                            </ul>
                        </div>
                    </nav>
                    <!-- Main Menu End-->

                    <!-- Outer box -->
                    <div class="outer-box">
                        <!--Search Box-->
                        <div class="search-box-btn"><span class="flaticon-search"></span></div>

                        <!-- Button Box -->
                        <div class="btn-box">
                            <a href="buy-ticket.html" class="theme-btn btn-style-one"><span class="btn-title">Get Tickets</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile Menu  -->
        <div class="mobile-menu">
            <div class="menu-backdrop"></div>
            <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header-->
            <nav class="menu-box">
                <div class="nav-logo"><a href="index.html"><img src="@/assets/images/logo-2.png" alt="" title=""></a></div>
                <ul class="navigation clearfix"><!--Keep This Empty / Menu will come through Javascript--></ul>
            </nav>
        </div><!-- End Mobile Menu -->
    </header>
    <!--End Main Header -->
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'Header',
    methods: {
        closeMobileMenu( ) {
            console.log('CloseMobileMenu')
        },
        initMenu() {
            //Mobile Nav Hide Show
            if(document.getElementsByClassName('mobile-menu').length){
                var mobileMenuContent = document.querySelector('.main-header .nav-outer .main-menu .navigation').innerHTML
                document.querySelector('.mobile-menu').innerHTML += '<div class="close-btn"><span class="icon flaticon-cancel-music"></span></div>'
                document.querySelector('.mobile-menu .navigation').innerHTML =mobileMenuContent
                document.querySelector(".mobile-menu .close-btn").addEventListener('click', function() {
                    document.getElementsByTagName('body')[0].classList.remove('mobile-menu-visible');
                });
                //Dropdown Button
                //Menu Toggle Btn Close
                document.querySelector('.mobile-menu .close-btn').addEventListener('click', function() {
                    document.getElementsByTagName('body')[0].classList.remove('mobile-menu-visible');
                });

                //Menu Toggle Btn
                document.querySelector('.mobile-nav-toggler').addEventListener('click', function() {
                    document.getElementsByTagName('body')[0].classList.add('mobile-menu-visible');
                });
            }
        },
        onScroll () {
            if(document.getElementsByTagName('header').length){
                var windowpos = document.documentElement.scrollTop
                var siteHeader = document.getElementsByTagName('header');
                if (windowpos >= 1) {
                    siteHeader[0].classList.add('fixed-header')
                } else {
                    siteHeader[0].classList.remove('fixed-header')
                }
            }
        }
    },
    beforeMount () {
        
    },
    mounted () {
        window.addEventListener('scroll', this.onScroll)
        this.initMenu()
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
})
</script>

